import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";

Vue.use(AclInstaller);

let initialRole = "editor";

let userInfo = JSON.parse(localStorage.getItem("userInfo"));
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole;

export default new AclCreate({
	initial: initialRole,
	notfound: "/pages/login",
	router,
	acceptLocalRules: true,
	globalRules: {
		isKCS: new AclRule("kcs"),
		isKCSXH: new AclRule("kcsxh"),
		isAdminXH: new AclRule("admin-xuat-hang"),
		isAccountant: new AclRule("accountant"),
		isAccountantBB: new AclRule("accountantbb"),
		isThuNgan: new AclRule("thungan"),
		isAdmin: new AclRule("admin").generate(),
		isEditor: new AclRule("editor").or("admin").or("buyer").generate(),
		isBuyer: new AclRule("buyer").generate(),
		isSpecial: new AclRule("special").or("admin").generate()
		// public: new AclRule("public").or("admin").or("editor").generate(),
	}
});
